import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCandy: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="candy, sweet"><circle cx="12" cy="12" r="5.25" stroke="currentColor" strokeWidth="1.5"/><path d="M16.9643 10.25C18.7515 9.81323 20.1043 9.00717 21.25 7.57143L16.4286 2.75C14.9928 3.89566 14.1868 5.24854 13.75 7.03571" stroke="currentColor" strokeWidth="1.5"/><path d="M7.03571 13.75C5.24854 14.1868 3.89566 14.9928 2.75 16.4286L7.57143 21.25C9.00717 20.1043 9.81323 18.7515 10.25 16.9643" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconCandy;
